import { Text, SimpleGrid, Button, useMantineTheme } from "@mantine/core";
import {
  PasswordRequirements,
  IMaskInputControlled,
  TextInputControlled,
  PasswordInputControlled,
  AcceptClientTerms,
} from "../../../components";
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  ISignUp,
  validationSignUp,
} from "../../../utils/validation/schemas/validationSignUp";
import { formatPhoneNumber } from "../../../utils/PHONEvalidation";
import { signUpUser, useUserIP } from "../../../hooks/useAuthService";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import LayoutFormAuth from "../_components/LayoutFormAuth";
import { useTranslation } from "react-i18next";
import { whitelabel_id } from "../../../api";
interface IProps {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading: boolean;
}
const SignUp = ({ setIsLoading, isLoading }: IProps) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const navigate = useNavigate();
  const {
    data: dataIp,
    //  isError: isErrorIp
  } = useUserIP();
  const userIp = !!dataIp?.data.ip ? dataIp?.data.ip : "";
  const [error, setError] = useState<string | null>(null);
  const abortControllerRef = useRef<AbortController | null>(null);

  const methods = useForm<ISignUp>({
    resetOptions: {
      keepValues: true,
    },
    mode: "onSubmit",
    resolver: yupResolver(validationSignUp),
    defaultValues: {
      name: "",
      document_nr: "",
      email: "",
      cell_phone: "",
      password: "",
      secondPassword: "",
      term_of_contract: false,
    },
  });

  const { handleSubmit, watch, setValue } = methods;

  const acceptTerm = watch("term_of_contract");
  const handleAcceptTerm = () => {
    setValue("term_of_contract", !acceptTerm);
  };

  const onSubmit: SubmitHandler<ISignUp> = async (data) => {
    setError(null);
    setIsLoading(true);
    const { term_of_contract, secondPassword, cell_phone, ...filteredData } =
      data;
    const phone = formatPhoneNumber(cell_phone);
    // if (!!!userIp && !!isErrorIp) {
    //   setError("Falha ao obter o endereço IP. Entre em contato com Suporte.");
    //   setIsLoading(false);
    //   return;
    // }
    const dataSend = {
      ...filteredData,
      cell_phone: phone,
      whitelabel_id: whitelabel_id,
      client_ip: userIp,
    };

    try {
      await signUpUser(dataSend, {
        signal: abortControllerRef.current?.signal,
      });
      navigate("/autenticacao/verficar-email");
    } catch (error: any) {
      const erro = error?.response?.data;
      if (!!!erro) {
        return setError(t("autenticacao.criar_conta.error_signup"));
      }
      if (erro?.statusCode === 409 && erro?.message.includes("Documento")) {
        setError(t("autenticacao.criar_conta.error_cpf"));
      } else if (erro.statusCode === 409) {
        setError(t("autenticacao.criar_conta.error_email"));
      } else {
        setError(t("autenticacao.criar_conta.error_signup"));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LayoutFormAuth<ISignUp> methods={methods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{
          display: "flex",
          gap: "24px",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Text
          fw={{ base: 600 }}
          fz={{ base: 24 }}
          lh={{ base: "37.2px" }}
          color={theme.colors.basic[5]}
        >
          {t("autenticacao.criar_conta.title")}
        </Text>
        <SimpleGrid
          cols={2}
          breakpoints={[{ maxWidth: "97rem", cols: 1, spacing: "md" }]}
          spacing="32px"
          verticalSpacing="24px"
        >
          <TextInputControlled
            name="name"
            label={t("global.input.name.label")}
            withAsterisk
            placeholder={t("global.input.name.placeholder")}
          />
          <IMaskInputControlled
            name="document_nr"
            label={t("global.input.document_nr.label")}
            placeholder="000.000.000-00"
            mask="000.000.000-00"
            withAsterisk
          />
          <TextInputControlled
            name="email"
            label={t("global.input.email.label")}
            withAsterisk
            placeholder={t("global.input.email.placeholder")}
          />

          <IMaskInputControlled
            name="cell_phone"
            label={t("global.input.cell_phone.label")}
            placeholder="(00) 00000-0000"
            mask="(00) 00000-0000"
            withAsterisk
          />
          <PasswordInputControlled
            name="password"
            label={t("global.input.password.label")}
            withAsterisk
            placeholder={t("global.input.password.placeholder")}
          />
          <PasswordInputControlled
            name="secondPassword"
            label={t("global.input.password_confirmation.label")}
            withAsterisk
            placeholder={t("global.input.password_confirmation.placeholder")}
          />
        </SimpleGrid>
        <PasswordRequirements
          passwordOne={watch("password")}
          passwordTwo={watch("secondPassword")}
        />
        <AcceptClientTerms
          acceptTerm={acceptTerm}
          handleAcceptTerm={handleAcceptTerm}
        />
        <Button
          type="submit"
          variant="primary"
          fullWidth
          loading={isLoading}
          disabled={!acceptTerm}
        >
          {t("autenticacao.criar_conta.title")}
        </Button>
        {error && <Text color="red">{error}</Text>}
      </form>
    </LayoutFormAuth>
  );
};

export default SignUp;
